module.exports.BURYATIA = "buryatia";
module.exports.CHECHNYA = "chechnya";
module.exports.CHUVA = "chuva";
module.exports.CRIMEA = "crimea";
module.exports.HMAO = "hmao";
module.exports.KALUG = "kalug";
module.exports.KARELIA = "karelia";
module.exports.KRASNODAR = "krasnodar";
module.exports.KURGAN = "kurgan";
module.exports.KURSK = "kursk";
module.exports.LITVA = "litva";
module.exports.MARIEL = "mariel";
module.exports.ORENB = "orenb";
module.exports.ORLOV = "orlov";
module.exports.PRIMOR = "primor";
module.exports.PSCOV = "pscov";
module.exports.SAAS = "saas";
module.exports.SAHALIN = "sahalin";
module.exports.SVERD = "sverd";
module.exports.TATAR = "tatar";
module.exports.VOLGOGRAD = "volgograd";
module.exports.YANAO = "yanao";
module.exports.LEN = "len";
module.exports.TAMBOV = "tambov";
module.exports.TULA = "tula";
module.exports.KAMCHATKA = "kamchatka";
module.exports.SARATOV = "saratov";
module.exports.CHUKOTKA = "chukotka";
